<template>
  <i18n tag="p" class="terms" path="RECAPTCHA_LABEL" >
    <sh-button
      href="https://policies.google.com/privacy"
      :naked="true"
      :theme-override="themeOverride"
    >
      {{ $t('RECAPTCHA_POLICY') }}
    </sh-button>
    <sh-button
      href="https://policies.google.com/terms"
      :naked="true"
      :theme-override="themeOverride"
    >
      {{ $t('RECAPTCHA_TERMS') }}
    </sh-button>
  </i18n>
</template>

<script>
export default {
  props: {
    themeOverride: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.terms {
  @include font('040');

  a {
    white-space: nowrap;
    @include underline(transparent)
  }
}
</style>
